import { useConfigStore } from 'stores/receiver/config'
import { useUserStore } from 'stores/receiver/account/user/user'

import { useRoleArray } from 'composables/common/auth/useRoleArray'

export const useCheckRoles = () => {
  const { checkRoleArray } = useRoleArray()
  /**
   * Checks if the user has the specified roles.
   *
   * @param rolesToCheck - An array of roles to check. (also accepts part of a role e.g. 'ADMIN_' will match 'ADMIN_USER')
   * @param all - Optional. If true, checks if all roles are present. If false, checks if at least one role is present. Default is true.
   * @returns True if the user has the specified roles, false otherwise.
   */
  const checkRoles = (rolesToCheck: string[], all = true) => {
    const userStore = useUserStore()
    return checkRoleArray(userStore.getRoles, rolesToCheck, all)
  }

  const checkFreeRoles = (rolesToCheck: string[], all = true) => {
    const configStore = useConfigStore()
    return checkRoleArray(configStore.freePermissions, rolesToCheck, all)
  }

  return { checkRoles, checkFreeRoles }
}
